var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex link",on:{"click":function () { return this$1.showTermsModal = this$1.showTermsModal !== true; }}},[_vm._v("\n    "+_vm._s(_vm.iconText)+"\n    "),_c('div',{class:_vm.iconClass},[_vm._v(" ")])]),_vm._v(" "),_c('TermsModal',{attrs:{"showTermsModal":_vm.showTermsModal}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31ae7568","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/ui/RegisterCardButton.vue
// module id = 1437
// module chunks = 65